import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type { GetFamilyLedgerDetailResponse } from './type';

export async function getFamilyLedgerDetail(
  personId: string,
  familyPersonId: string,
): Promise<GetFamilyLedgerDetailResponse> {
  const res = await apiClient.GET(
    '/v2/people-ledger/people/{personId}/family/{familyPersonId}/detail',
    {
      params: {
        path: { personId, familyPersonId },
      },
    },
  );
  return getDataOrThrowApiError(res);
}
